import { backgroundColorContainerSx, mainDivSx } from 'components/styles/container';
import { Box } from 'components/ui';
import { MenuProvider } from 'contexts/menu';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from 'utils/authentication';
import Loader from 'components/layout/loader';
import MainContainer from 'components/layout/main_container';

const PrivateNoSpaceRoute = () => {
  if (isAuthenticated()) {
    return (
      <Box sx={backgroundColorContainerSx}>
        <Box sx={mainDivSx}>
          <MainContainer>
            <MenuProvider>
              <Suspense fallback={<Loader />}>
                <Outlet />
              </Suspense>
            </MenuProvider>
          </MainContainer>
        </Box>
      </Box>
    );
  }
  return <Navigate to="/users/login" />;
};

export default PrivateNoSpaceRoute;
